export const CATALOG_TABLE_HEADER = 'picture';
export const CATALOG_TABLE_LEFT = 'preview-text';
export const CATALOG_TABLE_CENTER = 'text';
export const CATALOG_TABLE_RIGHT = 'text-under-picture';
